<template>
  <div id="s_upload">
    <div class="s_upload_image" v-if="imageSrc">
      <img :src="imageSrc" />
      <div
        class="s_upload_actions"
        :class="only_preview === true ? 'singleIcon' : 'multipleIcon'"
      >
        <i class="el-icon-search" @click="handlePreviewImage"></i>
        <i
          class="el-icon-delete"
          @click="handleDeleteImage"
          v-if="!only_preview"
        ></i>
      </div>
    </div>
    <div class="s_upload_uploader" v-else>
      <i class="el-icon-plus"></i>
      <el-upload
        :before-upload="handleBeforeUploadImage"
        :on-success="handleImageUploadSuccess"
        :show-file-list="false"
        :headers="headers"
        action="/declare/Upload/image"
      ></el-upload>
    </div>
  </div>
</template>

<script>
export default {
  name: "singleImageUpload",
  props: {
    imageSrc: {
      type: String,
      required: true,
      default: () => "",
    },
    tips: {
      type: String,
      required: false,
    },
    only_preview: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      headers: {},
    };
  },
  created() {
    this.headers = {
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    handleBeforeUploadImage(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.warning("只能上传JPG或PNG格式的图片！");
        return false;
      } else if (file.size > 1024 * 1024 * 4) {
        this.$message.warning("上传的图片大小不可超过4M");
        return false;
      }
      this.$emit("handleUploading");
    },
    handleImageUploadSuccess(res) {
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.$emit("handleUploadSuccess", res.data.uri);
      } else {
        this.$emit("handleUploadSuccess");
        this.$message.error(res.msg);
      }
    },
    handlePreviewImage() {
      this.$emit("handlePreviewImage", this.imageSrc);
    },
    handleDeleteImage() {
      this.$confirm("确定要删除已经上传的图片?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("handleDeleteImage");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
#s_upload {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  .s_upload_image {
    width: 160px;
    height: 100%;
    margin-right: 20px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .s_upload_actions {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 0 40px;
      visibility: hidden;
      i {
        font-size: 30px;
        color: #409eef;
        font-weight: 500;
        cursor: pointer;
      }
    }
    .s_upload_actions.singleIcon {
      justify-content: center;
    }
    .s_upload_actions.multipleIcon {
      justify-content: space-between;
    }
  }
  .s_upload_image:hover {
    .s_upload_actions {
      visibility: visible;
    }
  }
  .s_upload_uploader {
    width: 160px;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    .el-icon-plus {
      margin: 0;
      font-size: 32px;
      color: #d9d9d9;
    }
    > div:last-child {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      /deep/ .el-upload {
        width: 100%;
        height: 100%;
      }
    }
  }
  .s_upload_uploader:hover {
    border-color: #e40080;
    .el-icon-plus {
      color: #e40080;
    }
  }
}
</style>